import React from 'react';
import {
  Pressable,
  View,
  StyleSheet,
  ImageBackground,
  ScrollView,
  Text,
} from 'react-native';
import { Image } from 'expo-image';
import { colourConst } from '../../globalStyles';
import RainbowLine from '../RainbowLine';
import { useSetting } from './utils';
import SegmentedControl from '@react-native-segmented-control/segmented-control';
import TextLogOut from '../TextComponents/TextLogOut';
import { useLogout } from '../../hooks/useLogout';
import Legal from '../Legal';

const Settings = () => {
  const {
    temperatureUnit,
    handleTemperatureUnit,
    animatedStyles,
    tap,
    policiTextStyle,
    policyTap,
    mockText,
  } = useSetting();
  const { handleLogout } = useLogout();

  const temperatureOptions = ['Auto', 'Celsius (°C)', 'Fahrenheit (°F)'];
  const temperatureValues = ['auto', 'celsius', 'fahrenheit'];
  const selectedIndex = temperatureValues.indexOf(temperatureUnit);

  return (
    <View style={styles.pageContainer}>
      <RainbowLine>
        <ImageBackground
          source={require('../../../assets/watermark.png')}
          style={styles.background}
        >
          <Image
            style={styles.img}
            source={require('../../../assets/moreImg/Settings.png')}
          />
          <ScrollView style={styles.main}>
            <View style={styles.container}>
              <View style={styles.settingItem}>
                <Text style={styles.settingLabel}>Temperature Units</Text>

                <SegmentedControl
                  values={temperatureOptions}
                  selectedIndex={selectedIndex}
                  onChange={(event) => {
                    const index = event.nativeEvent.selectedSegmentIndex;

                    handleTemperatureUnit(
                      temperatureValues[index] as
                        | 'auto'
                        | 'celsius'
                        | 'fahrenheit'
                    );
                  }}
                  style={styles.segmentedControl}
                  tintColor={colourConst.blue}
                  backgroundColor={colourConst.inactiveGray}
                  fontStyle={{ color: colourConst.font }}
                  activeFontStyle={{ color: colourConst.white }}
                />
              </View>
            </View>
          </ScrollView>
          <Pressable style={styles.button} onPress={handleLogout}>
            <TextLogOut>LOG OUT</TextLogOut>
          </Pressable>
        </ImageBackground>
      </RainbowLine>
    </View>
  );
};

export default Settings;

const styles = StyleSheet.create({
  pageContainer: {
    flex: 1,
    width: '100%',
    maxWidth: 600,
    justifyContent: 'center',
    alignSelf: 'center',
  },
  main: {
    flex: 1,
  },
  container: {
    flex: 1,
    justifyContent: 'space-between',
    paddingHorizontal: 20,
  },
  settingItem: {
    marginBottom: 24,
  },
  settingLabel: {
    fontSize: 16,
    fontWeight: '600',
    marginBottom: 8,
    color: colourConst.font,
  },
  segmentedControl: {
    marginTop: 8,
    height: 40,
  },
  button: {
    backgroundColor: colourConst.blue,
    borderRadius: 10,
    paddingHorizontal: 10,
    paddingVertical: 0,
    marginVertical: 15,
    width: '90%',
    alignSelf: 'center',
  },
  background: {
    flex: 1,
  },
  img: {
    width: '100%',
    aspectRatio: 1.75,
    marginBottom: 30,
  },
});
